import { GET_DELIVERY_TABLE_DATA, SET_DELIVERY_TABLE_STATUS } from '../helpers/types';

const INITIAL_STATE = {
  deliveryDataArr: [],
  isLoading: false,
  listCount: null,
  top: 20,
  failText: '',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_DELIVERY_TABLE_DATA:
      return {
        ...state,
        deliveryDataArr: action.payload.data,
        isLoading: false,
        listCount: action.payload.listCount,
      };
    case SET_DELIVERY_TABLE_STATUS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
